import {
  emptyPreviewEnvironmentLogTails,
  sendPreviewEnvironmentManagerStatus,
} from './state.js';
import type { PreviewEnvironmentManagerRuntime } from './runtime.js';
import { parsePreviewEnvironmentDefs } from './parse-config.js';
import type { PreviewEnvironmentManagerState } from './state.js';
import { startPreviewEnvironment } from './start/index.js';
import { stopPreviewEnvironment } from './stop.js';

export function applyPreviewEnvironmentConfig(
  state: PreviewEnvironmentManagerState,
  servers: unknown,
): void {
  state.defsById.clear();
  for (const def of parsePreviewEnvironmentDefs(servers)) {
    state.defsById.set(def.environmentId, def);
  }
}

export function startPreviewEnvironmentById(
  runtime: PreviewEnvironmentManagerRuntime,
  state: PreviewEnvironmentManagerState,
  environmentId: string,
): void {
  const def = state.defsById.get(environmentId);
  if (!def) {
    runtime.log(`[preview-environment] Unknown server id ${environmentId.slice(0, 8)}…`);
    sendPreviewEnvironmentManagerStatus(
      runtime.getWs,
      environmentId,
      'error',
      'Unknown server',
      emptyPreviewEnvironmentLogTails(),
    );
    return;
  }
  if (!def.command.trim()) {
    sendPreviewEnvironmentManagerStatus(
      runtime.getWs,
      environmentId,
      'idle',
      'No command configured',
      emptyPreviewEnvironmentLogTails(),
    );
    return;
  }
  stopPreviewEnvironment(runtime, environmentId);
  startPreviewEnvironment(runtime, environmentId, def);
}
